import { render, staticRenderFns } from "./searchFeratelArrivals.vue?vue&type=template&id=d60f7e16&scoped=true"
import script from "./searchFeratelArrivals.vue?vue&type=script&lang=js"
export * from "./searchFeratelArrivals.vue?vue&type=script&lang=js"
import style0 from "./searchFeratelArrivals.vue?vue&type=style&index=0&id=d60f7e16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d60f7e16",
  null
  
)

export default component.exports